import type { Plugin } from "vue";
import markdownit from "markdown-it";
import { MarkdownItInjectionKey } from "@/symbols";
import MarkdownItAttrs from "markdown-it-attrs";

type MarkdownItPluginOptions = {
  /**
   * The prefix for the content in order the plugin to recognize it as markdown.
   */
  contentPrefix: string;
};

const MarkdownItPlugin: Plugin = {
  install(app, options: MarkdownItPluginOptions = { contentPrefix: ">md:" }) {
    const md = markdownit({
      linkify: false,
      // 🔴 Never `true`. Rendered strings go straight into `v-html` (`MarkedText`), and not all of
      // them are ours: mod names, BepInEx config comments and Workshop titles reach the same
      // renderer. With raw HTML allowed, `>md:<img src=x onerror=…>` in a customer-uploaded
      // file runs script in whoever opens that service's panel — including our staff (TR-5466).
      // Markdown alone cannot produce a script: markdown-it's `validateLink` drops `javascript:`,
      // `vbscript:`, `file:` and non-image `data:` URLs, and `markdown-it-attrs` below only passes
      // `target` and `rel`.
      html: false,
    });

    md.use(MarkdownItAttrs, {
      leftDelimiter: "[[",
      rightDelimiter: "]]",
      allowedAttributes: ["target", "rel"],
    });

    app.config.globalProperties.$md = md;
    app.config.globalProperties.$mdContentPrefix = options.contentPrefix;

    app.provide(MarkdownItInjectionKey, {
      md,
      contentPrefix: options.contentPrefix,
    });
  },
};

export default MarkdownItPlugin;
